import React from 'react';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import { useWatchButton } from '../../../../../../WatchButton/useWatchButton';
import { PapiDeviation } from '@wix/da-papi-types';

interface Props {
  deviation: PapiDeviation;
}

/** The watch button we use in our TopInfoBar. The watch button spec is confusing, so I want to warn that this shouldn't be used anywhere besides in the TopInfoBar. */
const TopInfoBarWatchButton: React.FC<Props> = ({ deviation }) => {
  const { isWatching, text, onClick, biData } = useWatchButton(
    deviation.author
  );

  return (
    <TextButton
      size="small"
      variant={isWatching ? 'main' : 'approval-green'}
      icon={isWatching ? CheckIcon : AddIcon}
      onClick={onClick}
      biData={biData}
    >
      {text}
    </TextButton>
  );
};
TopInfoBarWatchButton.displayName = 'TopInfoBarWatchButton';

export default TopInfoBarWatchButton;
